import { RouteRecordRaw } from 'vue-router';

export default {
  path: '/ai',
  name: 'ai',
  redirect: '/ai/textToImage/index',
  component: () => import('@/layout/index.vue'),
  meta: {
    title: 'menus.ai',
    icon: 'local-icon-AI',
    sort: 10
  },
  children: [
    {
      path: '/ai/textToImage/index',
      name: 'ai_textToImage',
      component: () => import('@/views/ai/textToImage/index.vue'),
      meta: {
        title: 'menus.ai_textToImage',
        icon: 'local-icon-AIGC-textToImg'
      }
    },
	{
	  path: '/ai/aiVoice/index',
	  name: 'ai_aiVoice',
	  component: () => import('@/views/ai/aiVoice/index.vue'),
	  meta: {
	    title: 'menus.ai_aiVoice',
	    icon: 'local-icon-AIGC-aiVoice'
	  }
	}
  ]
} as RouteRecordRaw;
